import React from 'react';
import { PropTypes } from 'prop-types';

const CustomTooltip = ({
  active,
  payload,
  unitName,
  isSenate = false
}) => {
  return active && payload && payload.length > 0 ? React.createElement("div", {
    className: "custom-tooltip",
    style: {
      borderLeft: "10px solid ".concat(payload[0].payload.partyColor)
    }
  }, React.createElement("p", {
    className: "name",
    style: {
      color: payload[0].payload.partyColor
    }
  }, payload[0].payload.partyAcronym), payload[0].payload.seats ? React.createElement("p", {
    className: "esc"
  }, Number(payload[0].payload.seats).toLocaleString('es'), " ", unitName) : null, payload[0].payload.votesPercent && !isSenate ? React.createElement("p", {
    className: "percent"
  }, Number(payload[0].payload.votesPercent).toLocaleString('es'), " % votos") : null, payload[0].payload.votes && !isSenate ? React.createElement("p", {
    className: "percent"
  }, Number(payload[0].payload.votes).toLocaleString('es'), " votos") : null) : null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({})),
  unitName: PropTypes.string
};
CustomTooltip.defaultProps = {
  active: false,
  payload: [],
  unitName: ''
};
export default CustomTooltip;